import React, { Component } from 'react';
import 'leaflet/dist/leaflet.css';
import Leaflet from 'leaflet'

// コンポーネント読み込み
import MyMap from '../components/MyMap'
import SpotDetail from '../components/SpotDetail'

Leaflet.Icon.Default.imagePath =
  '//cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/'

class Search extends Component {
  constructor(props: Props) {
    // Initialize the viewport to the one provided in props
    super(props)
    this.state = {
      zoom: 11,
      mapStyle: {
        width: 100+'%', height: 300+'px', borderRadius: 10+'px'
      },
      selectedSpot: null,
    }
    this.setSelectedSpot = this.setSelectedSpot.bind(this)
    this.initSelectedSpot = this.initSelectedSpot.bind(this)
  }

  initSelectedSpot() {
    this.setState({selectedSpot: null})
  }

  setSelectedSpot(spot) {
    this.setState({selectedSpot: spot})
  }

  render() {
    return (
      <div className="Search">
        <MyMap zoom={11} style={this.state.mapStyle} spotList={this.props.spotList} initSelectedSpot={this.initSelectedSpot} setSelectedSpot={this.setSelectedSpot}/>
        <SpotDetail selectedSpot={this.state.selectedSpot} changeSpotListState={this.props.changeSpotListState}/>
      </div>
    );
  }
}

export default Search;
